import { ApiException } from '@eta/components';
import {
    InvitationActionTypes,
    LOAD_CURRENT_INVITATION,
    ACCEPT_INVITATION,
    COMPLETE_PROFILE,
} from './Types';
import { CheckDelegationInvitationValidityQueryResponse } from '../../Services/ClientProxy/clientProxy';

export interface InvitationState {
    currentInvitation?: CheckDelegationInvitationValidityQueryResponse;
    lastError?: ApiException;
}

const initialState: InvitationState = {};

export function invitationReducer(
    state = initialState,
    action: InvitationActionTypes
) {
    switch (action.type) {
        case LOAD_CURRENT_INVITATION:
            
            return {
                ...state,
                currentInvitation: { ...action.payload },
                ...action.payload,
            };
        case ACCEPT_INVITATION:
            return {
                ...state,
                ...action.payload,
            };
        case COMPLETE_PROFILE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}
